var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSiginupBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 1300,
    viewBox: "0 0 1920 1300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.a{stroke:#707070;}.c{opacity:0.07;}.d{clip-path:url(#a);}.e{clip-path:url(#b);}.f{fill:none;stroke:#1f5ca9;stroke-miterlimit:4.001;stroke-width:0.5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1920,
    height: 1300,
    transform: "translate(0 -63)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1702.357,1679.48,9935.947-910.411,7536.922,4964.665-696.667,7554.555Z",
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(0 63)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(-4237.27 3212.053) rotate(-46)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 17516.129, 2641.452)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-46.711,507.443c487.083,270.913,2960.154,702.487,4228.531-166.681C5786.055-758.55,8196.937-1170,8318.782,654.727s3125.486,1766.074,4858.3,1442.933",
    transform: "translate(2778.312 -247.705)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-47.624,517.37c397.822,353.8,2925.4,739.306,4192.007-130.653C5754.669-719.85,8321.974-1228.166,8443.83,596.556s2905.771,1881.738,4638.581,1558.6",
    transform: "translate(2729.792 -208.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-48.729,529.372c308.552,436.681,2890.637,776.134,4155.474-94.622C5723.077-679.07,8446.822-1284.26,8568.67,540.464s2686.064,1997.408,4418.886,1674.268",
    transform: "translate(2681.475 -172.276)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-50.022,543.415c219.289,519.568,2855.881,812.964,4118.949-58.589C5691.3-636.248,8571.482-1338.314,8693.339,486.406s2466.358,2113.078,4199.17,1789.94",
    transform: "translate(2633.336 -137.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-51.5,559.453c130.01,602.456,2821.118,849.788,4082.424-22.56C5659.351-591.44,8695.96-1390.372,8817.806,434.351s2246.659,2228.742,3979.468,1905.6",
    transform: "translate(2585.389 -104.998)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-53.152,577.423c40.749,685.339,2786.361,886.618,4045.9,13.469C5627.216-544.69,8820.266-1440.5,8942.115,384.222S10969.057,2728.638,12701.864,2405.5",
    transform: "translate(2537.612 -74.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-54.978,597.259c-48.523,768.229,2751.6,923.446,4009.365,49.5,1640.516-1142.84,4990-2135.523,5111.855-310.8S10873.467,2796.051,12606.287,2472.9",
    transform: "translate(2490.016 -45.451)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-56.051,618.811c-137.782,851.106,2716.842,960.272,3972.843,85.527C5563.35-445.749,9069.275-1535.306,9191.123,289.416s1587.533,2575.747,3320.343,2252.61",
    transform: "translate(2441.656 -18.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-54.132,641.8c-227.062,934,2682.069,997.1,3936.308,121.563C5534.79-393.987,9197.147-1580.415,9318.993,244.309s1367.819,2691.419,3100.628,2368.282",
    transform: "translate(2390.315 7.368)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-49.43,666.164C-365.753,1683.046,2597.884,1700.091,3850.354,823.756c1658.658-1164.6,5477.45-2447.9,5599.3-623.18s1148.109,2807.09,2880.921,2483.952",
    transform: "translate(2336.182 31.681)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-42.232,691.857c-405.593,1099.767,2612.55,1070.755,3863.25,193.623C5485.724-286.377,9460.952-1666.55,9582.8,158.168S10511.2,3080.931,12244.019,2757.79",
    transform: "translate(2279.56 54.669)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-32.779,718.5C-527.635,1901.152,2546.469,1826.8,3793.946,948.154,5466.654-230,9596.36-1708.006,9718.217,116.715s708.693,3038.427,2441.5,2715.29",
    transform: "translate(2220.676 76.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-21.318,746.663C-605.453,2012.205,2523.248,1891.823,3768.873,1012.35,5447.742-173.01,9733.774-1747.937,9855.621,76.787s488.987,3154.092,2221.8,2830.956",
    transform: "translate(2159.793 97.216)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-8.028,775.987C-681.424,2124.413,2501.852,1958,3745.638,1077.7,5430.665-114.874,9873.027-1786.711,9994.876,38.006s269.275,3269.764,2002.082,2946.628",
    transform: "translate(2097.07 116.575)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M6.932,806.4C-755.734,2237.71,2482.1,2025.261,3724.066,1144.147,5415.232-55.647,10013.929-1824.391,10135.786.329s49.56,3385.433,1782.376,3062.293",
    transform: "translate(2032.688 134.837)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M23.408,837.864c-851.927,1514.193,2440.474,1255.694,3680.61,373.775C5401.317,4.611,10156.371-1861.034,10278.219-36.31s-170.142,3501.1,1562.669,3177.964",
    transform: "translate(1966.778 152.057)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M41.281,870.3c-941.206,1597.081,2405.75,1292.54,3644.074,409.811C5388.772,65.85,10300.2-1896.693,10422.045-71.969S10032.192,3544.8,11765,3221.668",
    transform: "translate(1899.483 168.296)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M60.427,903.666c-1030.468,1679.969,2371.022,1329.377,3607.551,445.84C5377.5,128.005,10445.295-1931.419,10567.141-106.7S9957.584,3625.743,11690.4,3302.6",
    transform: "translate(1830.907 183.608)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M80.747,937.918c-1119.738,1762.853,2336.283,1366.2,3571.028,481.867,1715.607-1228.744,6939.8-3385.054,7061.644-1560.331s-829.271,3848.106,903.546,3524.967",
    transform: "translate(1761.162 198.037)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M102.147,973c-1209,1845.736,2301.542,1403.029,3534.5,517.9C5358.338,254.9,10738.926-1998.288,10860.778-173.565S9811.8,3790.21,11544.611,3467.073",
    transform: "translate(1690.331 211.637)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M124.554,1008.854c-1298.28,1928.629,2266.787,1439.854,3497.967,553.932C5350.281,319.537,10887.281-2030.521,11009.127-205.8s-1268.679,4079.441,464.13,3756.3",
    transform: "translate(1618.502 224.454)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M147.881,1045.463c-1387.539,2011.506,2232.03,1476.665,3461.446,589.954C5343.141,384.913,11036.57-2062.015,11158.419-237.293s-1488.4,4195.114,244.412,3871.977",
    transform: "translate(1545.742 236.529)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M172.072,1082.764c-1476.811,2094.4,2197.256,1513.482,3424.91,625.992C5336.848,450.98,11186.709-2092.81,11308.566-268.088S9600.453,4042.7,11333.272,3719.559",
    transform: "translate(1472.129 247.903)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M197.061,1120.724C-1369.011,3298,2359.543,2671.017,3585.445,1782.749,5331.34,517.7,11337.658-2122.943,11459.5-298.22s-1927.8,4426.45-194.994,4103.308",
    transform: "translate(1397.709 258.621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M222.8,1159.315c-1655.35,2260.167,2127.686,1587.1,3351.854,698.051C5326.573,585.041,11489.344-2152.451,11611.2-327.73s-2147.518,4542.116-414.706,4218.978",
    transform: "translate(1322.545 268.711)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M249.232,1198.494C-1495.381,3541.548,2342.126,2822.4,3564.56,1932.577c1757.92-1279.61,8077.176-4113.948,8199.023-2289.225S9396.357,4301.139,11129.169,3978",
    transform: "translate(1246.682 278.211)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M276.319,1238.223C-1557.565,3664.164,2334.4,2898.933,3555.113,2008.338,5319.028,721.445,11794.773-2209.733,11916.618-385.009S9329.683,4388.444,11062.5,4065.306",
    transform: "translate(1170.175 287.156)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M304.01,1278.494c-1923.144,2508.822,2023.279,1697.5,3242.27,806.143,1769.9-1294.193,8402.142-4322.2,8524-2497.481S9263.632,4476.282,10996.442,4153.145",
    transform: "translate(1093.05 295.569)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M332.281,1319.255c-2012.422,2591.709,1988.448,1734.3,3205.735,842.179C5313.883,859.947,12102.644-2264.9,12224.493-440.176s-3026.352,5004.8-1293.542,4681.658",
    transform: "translate(1015.356 303.483)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M361.2,1360.631C-1740.485,4035.229,2313.32,3131.1,3530.412,2238.839,5310.02,929.15,12257.523-2291.617,12379.375-466.9S9133.306,4653.57,10866.121,4330.427",
    transform: "translate(937.005 310.785)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M390.513,1402.3C-1800.441,4159.782,2307.867,3209.6,3523.19,2316.542,5308.852,999.592,12412.783-2318.044,12534.63-493.321S9068.86,4742.806,10801.681,4419.666",
    transform: "translate(858.27 317.794)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M420.3,1444.4C-1859.92,4284.766,2302.9,3288.524,3516.45,2394.667c1791.706-1324.2,9052.08-4738.714,9173.926-2913.991S9004.9,4832.474,10737.71,4509.338",
    transform: "translate(779.055 324.375)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M450.534,1486.9C-1918.959,4410.147,2298.372,3367.847,3510.164,2473.2c1797.744-1331.455,9214.549-4842.836,9336.405-3018.12S8941.381,4922.546,10674.19,4599.409",
    transform: "translate(699.393 330.556)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M481.19,1529.78c-2458.756,3006.136,1813.08,1917.778,3023.1,1022.329C5308.082,1213.4,12881.328-2394.86,13003.176-570.137S8878.282,5013,10611.093,4689.862",
    transform: "translate(619.307 336.354)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M512.25,1573.024c-2548.028,3089.026,1778.316,1954.6,2986.57,1058.359,1809.845-1345.965,9539.52-5051.1,9661.367-3226.372S8815.58,5103.821,10548.4,4780.68",
    transform: "translate(538.825 341.785)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M543.682,1616.621C-2093.6,4788.523,2287.242,3608.051,3493.728,2711.009c1815.888-1353.218,9702-5155.226,9823.858-3330.505s-4564.313,5814.473-2831.5,5491.337",
    transform: "translate(457.96 346.872)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M575.483,1660.533C-2151.085,4915.33,2284.28,3688.792,3489,2790.952,5310.93,1430.48,13353.479-2468.4,13475.329-643.673s-4784.017,5930.138-3051.21,5607",
    transform: "translate(376.736 351.635)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M607.616,1704.766C-2208.213,5042.446,2281.656,3769.855,3484.6,2871.219,5312.592,1503.491,13511.569-2492.26,13633.423-667.539S8629.69,5378.274,10362.5,5055.136",
    transform: "translate(295.173 356.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M640.075,1749.3C-2265.024,5169.863,2279.352,3851.21,3480.53,2951.776,5314.564,1576.8,13669.982-2515.831,13791.827-691.105S8568.39,5470.378,10301.208,5147.237",
    transform: "translate(213.29 360.228)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M672.837,1794.109C-2321.522,5297.556,2277.359,3932.846,3476.767,3032.62,5316.848,1650.385,13828.7-2539.113,13950.55-714.389S8507.407,5562.758,10240.216,5239.62",
    transform: "translate(131.096 364.096)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M705.9,1839.19C-2377.74,5425.53,2275.657,4014.76,3473.3,3113.738,5319.421,1724.244,13987.71-2562.125,14109.568-737.4S8446.709,5655.416,10179.521,5332.272",
    transform: "translate(48.611 367.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M739.232,1884.536c-3172.9,3669.222,1535,2212.39,2730.874,1310.57,1852.177-1396.744,10676.9-5779.99,10798.748-3955.267S8386.289,5748.325,10119.1,5425.188",
    transform: "translate(-34.153 371.027)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiginupBg);
export default __webpack_public_path__ + "static/media/siginup_bg.de63e8ec7d12d2cd07d0afb2c914bdeb.svg";
export { ForwardRef as ReactComponent };